<template>
  <div class="radius-box">
    <div class="example-box">
      <div
        class="example"
        :style="{
          'border-radius': `${radius}px`,
        }"
      ></div>
    </div>
    <div class="split-box">
      <div class="border-top-left-radius"></div>
      <div class="border-top-right-radius"></div>
      <div class="border-bottom-left-radius"></div>
      <div class="border-bottom-right-radius"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "radiusBox",
  props: {
    radius: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.radius-box {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  position: relative;
}

.radius-box > div {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.radius-box .split-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 5px;
}

.radius-box .split-box > div {
  width: 48%;
  border: 1px dashed #999;
  margin-bottom: 4px;
}

.radius-box .example-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.radius-box .example-box .example {
  width: 60px;
  height: 60px;
  border: 1px solid #000;
}
</style>
